import React, { useEffect, useMemo, useState } from "react";
import { FaCircle, FaRegCircle } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const [selectedItem, setSelectedItem] = useState("");

  const settingsRoutes = useMemo(
    () => ["/email-configuration", "/website-settings"],
    []
  );


  useEffect(() => {
    const isSettingsRoute = settingsRoutes.some((route) =>
      currentPath.includes(route)
    );
    setSelectedItem(isSettingsRoute ? "Settings" : "");
  }, [currentPath, settingsRoutes]);

  const shouldHideSidebar =
    currentPath === "/" || currentPath === "/forgot-password";

  return (
    <nav
      className={`sidebar sidebar-offcanvas ${shouldHideSidebar ? "d-none" : ""
        }`}
      id="sidebar"
    >
      <ul className="nav">
        <li
          className={`nav-item nav-profile ${currentPath === "/dashboard" ? "active" : ""
            }`}
        >
          <Link className="nav-link" to="/dashboard">
            <span className="menu-title">Dashboard</span>
          </Link>
        </li>
        <li
          className={`nav-item ${currentPath === "/customers" ? "active" : ""}`}
        >
          <Link className="nav-link" to="/customers">
            <span className="menu-title">Customers</span>
          </Link>
        </li>
        <li className={`nav-item ${currentPath === "/products" ? "active" : ""}`}>
          <Link className="nav-link" to="/products">
            <span className="menu-title">Products</span>
          </Link>
        </li>
        <li
          className={`nav-item ${currentPath === "/schedule-notification" ? "active" : ""}`}
        >
          <Link className="nav-link" to="/schedule-notification">
            <span className="menu-title">Schedule Notification</span>
          </Link>
        </li>
        <li
          className={`nav-item ${currentPath === "/notification-history" ? "active" : ""}`}
        >
          <Link className="nav-link" to="/notification-history">
            <span className="menu-title">Notifications History</span>
          </Link>
        </li>
        <li
          className={`nav-item ${currentPath === "/abandoned-checkout" ? "active" : ""}`}
        >
          <Link className="nav-link" to="/abandoned-checkout">
            <span className="menu-title">Abandoned Checkout</span>
          </Link>
        </li>
        <li
          className={`nav-item ${selectedItem === "Email Configuration" ||
            selectedItem === "Website Settings"
            ? "active"
            : ""
            }`}
        >
          <div
            className="nav-link"
            onClick={() => {
              setSelectedItem(selectedItem === "Settings" ? "" : "Settings");
            }}
            style={{ cursor: "pointer" }}
          >
            <span className="menu-title">Settings</span>
            <i
              className={`menu-icon ${selectedItem === "Settings"
                ? "icon-arrow-down"
                : "icon-arrow-right"
                }`}
            />
          </div>

          {selectedItem === "Settings" && (
            <div className="sub-menu-container">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/email-configuration"
                    onClick={() => setSelectedItem("Email Configuration")}
                  >
                    {currentPath === "/email-configuration" ? (
                      <FaCircle className="circle-icon mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Email Configuration
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default Sidebar;
